import { ErrorResponse } from '../models/responses/ErrorResponse';
import { RootUserResponse } from '../models/responses/RootUserResponse';

export const errorTranslator = (response: RootUserResponse<ErrorResponse>) => {
  const { errors, identifiers } = response.user;

  return {
    errors,
    identifiers,
  };
};
